module.exports = "/_next/static/images/PredictiveAI@2x-2fb521f7ced6f90541a4afe35b9d5cc7.webp";